package com.macrofocus.eflux.ui.layer

import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.deckgl.polygonToDeckGL
import com.macrofocus.eflux.network.lightning.LightningCluster
import com.macrofocus.eflux.network.schema.Schema
import deckgl.PolygonLayer
import js.objects.unsafeJso
import mui.material.styles.Theme

fun createSchemaLayer(
    dataLoader: DataLoader,
    schemas: Array<Schema>?,
    cartographic: Double,
    theme: Theme,
    isCartographicZoomed: Boolean,
    getSchemas: Boolean
) : PolygonLayer<Schema> {
    val array = if(schemas != null) schemas else emptyArray()

    return PolygonLayer<Schema>(unsafeJso {
        id = "schema-layer"

        visible = getSchemas

        this.data = array
        opacity = if(isCartographicZoomed) 0.05 else 1.0
        asDynamic().positionFormat = "XY"
        asDynamic().getPolygon = { d: Schema ->
            val polygon = d.logicalGeometry
            polygonToDeckGL(polygon)
        }
        asDynamic().filled = true
        asDynamic().getFillColor = arrayOf(255, 255, 255, 0)
        asDynamic().stroked = false
        asDynamic().lineWidthUnits = "pixels"
        asDynamic().lineWidthMinPixels = 0.5
        asDynamic().getLineColor = { c: LightningCluster ->
            if(isCartographicZoomed) arrayOf(0, 0, 0, 31) else arrayOf(0, 0, 0, 63)
        }
        pickable = true
        autoHighlight = true
        highlightColor = if(isCartographicZoomed) arrayOf(255, 200, 0, 31) else arrayOf(255, 200, 0, 63)
        updateTriggers = unsafeJso {
            this.asDynamic().opacity = arrayOf(isCartographicZoomed)
            this.asDynamic().getFillColor = arrayOf(isCartographicZoomed)
            this.asDynamic().highlightColor = arrayOf(isCartographicZoomed)
        }
        onHover = { info ->
            val o = info.`object`
            if (o != null) {
                if (o is Schema) {
                    val schema = (o as Schema)
                    dataLoader.schemaProbing.selected = schema
                } else {
                    dataLoader.schemaProbing.clearSelection()
                }
            } else {
                dataLoader.schemaProbing.clearSelection()
            }
        }
        onClick = { info: dynamic ->
            val o = info.`object`
            if (o != null) {
                if (o is Schema) {
                    val schema = (o as Schema)
                    dataLoader.schemaSelection.setSelectedElement(schema)
                } else {
                    dataLoader.schemaSelection.clearSelection()
                }
            } else {
                dataLoader.schemaSelection.clearSelection()
            }
        }

    })
}
